import { render, staticRenderFns } from "./GroupProtocol.vue?vue&type=template&id=007014c2&"
import script from "./GroupProtocol.vue?vue&type=script&lang=js&"
export * from "./GroupProtocol.vue?vue&type=script&lang=js&"
import style0 from "./GroupProtocol.vue?vue&type=style&index=0&id=007014c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports